import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { AppFeaturesLang, AppFeaturesState } from './app-feature.state';
import { AppFeaturesService } from './app-features.service';

// Route Resolver used to detect and preload language data from server before showing template
export const langResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot): Promise<void> => {
	const store = inject(Store);
	const appFeatures = inject(AppFeaturesState);
	const appFeaturesService = inject(AppFeaturesService);

	let requestLang = await appFeaturesService.getCurrentLang();
	const { lang, langData } = appFeatures;

	if (Object.keys(langData).length > 0 && requestLang === lang) {
		return;
	}

	switch (route.url.shift()?.path) {
		case 'login':
			// login resolver
			if (route.queryParamMap.has('lang')) {
				requestLang = route.queryParamMap.get('lang');
			}
			break;
		default:
			console.log('after login resolver');
			break;
	}

	if (requestLang === null) requestLang = 'en';

	store.dispatch(new AppFeaturesLang(requestLang));

	return;
};
